/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Game } from './Game.js';
import { Lobby } from './Lobby.js';
import { disconnectClient, leaveCurrentRoom } from './utils/photon/client.js';
import { Header } from './Header.js';
import { Logs } from './Logs.js';
import { Banners } from './Banners.js';
import { Footer } from './Footer.js';
import { IS_LOCAL } from './config/env.js';
import { nap } from './utils/utils.js';
import { prepLogMessage } from './utils/UI/logs.js';
import './Home.scss';

export const Home = ({ setAppData, handleLogout, appData }) => {
  const { loggedInUser, waitingOpponent } = appData;

  const [isLobbyRefresh, setLobbyRefresh] = useState(false);

  // Progress on UI
  const [uiMessages, setUiMessages] = useState(['Waiting for players to join']);
  const addMsg = (
    msg,
    msgConfig = {},
  ) => {
    if (!IS_LOCAL && msgConfig.dev) return; // dont add dev logs to UI
    const newMsg = prepLogMessage({ msg, msgConfig });
    setUiMessages((prevMessages = []) => [...prevMessages, newMsg]);
  };


  // Logout
  const handleDisconnect = () => {
    leaveCurrentRoom();
    disconnectClient();
    handleLogout();
  };


  // ## NEW MATCHES

  // Found Player
  const handleFoundPlayer = (playersInfo = {}) => {
    const { activePlayers, masterName, masterColor, roomName } = playersInfo;
    if (!waitingOpponent) return;
    setUiMessages([]); // clear lobby logs
    setAppData({ // show game
      ...appData,
      players: {
        ...activePlayers, // found both in Photon room, 1st is master
        masterName, masterColor, // SET MASTER AND COLOR
      },
      room: {
        roomID: roomName, // NEW ROOM NAME
      },
      waitingOpponent: false, // DISMISS LOBBY, START GAME
    });
  };

  // Back to Lobby
  const backToLobby = async ({ clearFilters = false } = {}) => {
    setUiMessages([]); // clear previous match logs
    leaveCurrentRoom();
    disconnectClient(); // clean state for new room
    if (clearFilters) {
      // client disconnected, remount lobby to re-init client
      setLobbyRefresh(true);
      await nap(3 * 1000);
      setLobbyRefresh(false);
    }
    setAppData({
      ...appData,
      players: {},
      room: {
        roomID: appData.room.roomID, // previous room
      },
      isInviteMatch: false, // clear if it was
      waitingOpponent: true, // DISMISS GAME, START LOBBY
    });
  };

  // Rematch
  const rematchRequest = () => {
    setUiMessages([]); // clear previous match logs
    leaveCurrentRoom();
    disconnectClient(); // clean state for new room (increased #)
    const { room } = appData;
    setAppData({
      ...appData,
      room: {
        roomID: room.roomID, // previous room
      },
      isInviteMatch: true, // TURN IT INTO INVITE GAME
      waitingOpponent: true, // DISMISS GAME, START LOBBY
    });
  };

  // Join after generating Invite Link
  const joinMyInviteLink = ({ invitePlayers }) => {
    setUiMessages([]); // clear previous match logs
    leaveCurrentRoom();
    disconnectClient(); // clean state for new room
    const { room = {} } = appData;
    setAppData({
      ...appData,
      players: { ...invitePlayers },
      room: {
        roomID: room.roomID, // previous room, in this case just to skip it
      },
      isInviteMatch: true,
      waitingOpponent: true, // DISMISS GAME, START LOBBY
    });
  };


  return (
    <div className="home">
      {/* HEADER */}
      <Header {...{ loggedInUser, handleDisconnect, joinMyInviteLink }} />

      <div className="main-content">
      {/* BANNERS */}
        <Banners/>

        {/* LOBBY OR GAME */}
        <div className="main-container">
          {waitingOpponent ?
            <>{isLobbyRefresh
                ? <p className="loading">Loading...</p>
                : <Lobby
                    appData={appData}
                    addMsg={addMsg}
                    onStartGame={handleFoundPlayer}
                    clearInvite={backToLobby}
                  />
            }</>
          : (
            <Game
              appData={appData}
              addMsg={addMsg}
              handlers={{ rematchRequest, backToLobby }}
            />
          )}
        </div>

        {/* JOURNAL */}
        <Logs className="logs" {...{ uiMessages, loggedInUser, appData, addMsg }} />
      </div>

      {/* FOOTER */}
      <Footer {...{ addMsg, voter: loggedInUser }}/>
    </div>
  );
};
